import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type LiveTranscriptionAvailabilityFetchFailedAction = {
	type: 'LIVE_TRANSCRIPTION_AVAILABILITY_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): LiveTranscriptionAvailabilityFetchFailedAction => ({
	type: 'LIVE_TRANSCRIPTION_AVAILABILITY_FETCH_FAILED',
	payload,
});
